// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__dZ-_P","additionalInfo":"AgreementModal_additionalInfo__2RbtG"};